var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PieChart"},[(_vm.hasData)?_c('GChart',{attrs:{"type":"PieChart","settings":{packages: ['corechart', 'table'], language: 'nl'},"data":_vm.chartData,"options":_vm.chartOptions}}):_vm._e(),_c('div',{staticClass:"Text Text--fallback",domProps:{"textContent":_vm._s('Datawaarden zijn te laag om cirkeldiagram weer te geven')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }